<style lang='scss' src='./index.scss' scoped></style>

<template>
  <!-- VIP全部特权 -->
  <section class="mod_privilege" v-report.expose="report('',null,true)">
    <div class="wrap_title">
      <div class="left">{{title}}</div>
    </div>
    <div class="list transverse_list">
      <div class="left_show" v-if="todayPrivilege" v-report="report('detail',{c_privilege_name: todayPrivilege.c_privilege_name})">
        <a class="top" :href="todayPrivilege.linkUrl">
          <img :src="todayPrivilege.c_icon_url" alt="" class="current_img">
          &nbsp;{{todayPrivilege.c_privilege_name}}
        </a>
        <a class="bottom" :href="todayPrivilege.linkUrl">
          <div class="title">今日特权</div>
          <div class="txt" v-html="diyData">
          </div>
        </a>
      </div>
      <ul>
        <li class="item" :key="index" v-for="(item,index) in groups">
          <a class="top" v-if="privileges.top && privileges.top.length>0 && privileges.top[index]"
            :href="privileges.top[index].linkUrl"
            v-report="report('detail', privileges.top[index])">
            <img :src="privileges.top[index].c_icon_url" alt="" class="img">
            <span class="txt">{{privileges.top[index].c_main_title}}</span>
            <div class="desc">{{privileges.top[index].c_second_title}}</div>
          </a>
          <a class="bottom" v-if="privileges.bottom && privileges.bottom.length>0 && privileges.bottom[index]"
            :href="privileges.bottom[index].linkUrl"
            v-report="report('detail',privileges.bottom[index])">
            <img :src="privileges.bottom[index].c_icon_url" alt="" class="img">
            <span class="txt">{{privileges.bottom[index].c_main_title}}</span>
            <div class="desc">{{privileges.bottom[index].c_second_title}}</div>
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { request } from '@tencent/vft-common/request'
import atom from '@tencent/vft-atom'


const PRIVILEGE = {
  f_module: 'VIP全部特权',
  f_hottag: 'vippriv',
  MORE: {
    f_hottag: 'mypriv_more',
    f_resource: '更多'
  },
  DETAIL: {
    f_hottag: 'vippriv_detail',
    f_resource: '特权'
  }
}

export default {
  props: {
    title: {
      type: String,
      default: 'VIP全部特权'
    }
  },
  data() {
    return {
      privileges: {
        top: [],
        bottom: []
      },
      todayPrivilege: null,
      groups: 0
    }
  },
  computed: {
    diyData() {
      if (this.todayPrivilege && this.todayPrivilege.diyData) {
        return this.todayPrivilege.diyData.replace(/&lt;!--(\d+\.?\d{0,3}%?)--&gt;/g, '<span class="num">$1</span>')
      } else {
        return ''
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async reqPrivileges() {
      return request('//vip.video.qq.com/fcgi-bin/comm_cgi?name=get_vip_privilege_multi_platform&cmd=12').then(res => {
        if (!res || res.ret!=0) {
          return null;
        }
        return res;
      })
    },
    async init() {
      let privilegeUrl = `https://film.qq.com/x/autovue/privilege/?pid=privilege${this.isHideToolBar?'&hidetitlebar=1&hidestatusbar=0&style=titlecolor%3d%23ffffff%26contentbkcolor%3d%23fdf6e2':''}&title=`;
      let _privileges = await this.reqPrivileges();
      if (_privileges && _privileges.diyData) {
        this.todayPrivilege = {};
        this.todayPrivilege.c_icon_url = _privileges.c_icon_url;
        this.todayPrivilege.c_main_title = _privileges.c_main_title;
        this.todayPrivilege.c_privilege_name = _privileges.c_privilege_name;
        this.todayPrivilege.c_second_title = _privileges.c_second_title;
        this.todayPrivilege.diyData = _privileges.diyData;
        this.todayPrivilege.linkUrl = `${privilegeUrl}${encodeURIComponent(_privileges.c_privilege_name)}`
      } else {
        this.todayPrivilege = null;
      }

      if (_privileges && _privileges.list) {
        let _filterList = _privileges.list;
        if (this.todayPrivilege) { //前端过滤掉和今日特权重复的特权
          _filterList = _filterList.filter(item => {
            return item.c_main_title != this.todayPrivilege.c_main_title;
          })
        }
        this.groups = _filterList.length % 2 == 0 ? _filterList.length / 2 : Math.floor(_filterList.length / 2) + 1;

        if (this.groups > 0) { //登入登出需要重新过滤显示特权
          this.privileges = {
            top: [],
            bottom: []
          };
        }

        _filterList.filter((item, index) => {
          item.linkUrl = `${privilegeUrl}${encodeURIComponent(item.c_privilege_name)}`;
          if (index % 2 == 0) {
            this.privileges.top.push(item);
          } else {
            this.privileges.bottom.push(item);
          }
          return item;
        });
      }
    },
    report(type, item, isModule=false) {
      let _param = $.extend({}, {}, {
        f_type: isModule ? 1 : 4,
        f_module: PRIVILEGE.f_module
      });
      if (isModule) {
        _param = $.extend(_param, {
          f_hottag: PRIVILEGE.f_hottag
        });
        return _param;
      }
      switch (type) {
        case 'more':
          _param = $.extend(_param, PRIVILEGE.MORE);
          break;
        case 'detail':
          _param = $.extend(_param, {
            f_hottag: PRIVILEGE.DETAIL.f_hottag,
            f_resource: item.c_privilege_name
          });
          break;
      }
      return _param;
    }
  }
}
</script>
